import { render, staticRenderFns } from "./TransactionForeignAmount.vue?vue&type=template&id=c2e81206&"
import script from "./TransactionForeignAmount.vue?vue&type=script&lang=js&"
export * from "./TransactionForeignAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports